<template>
  <svg  viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1.46967" y1="10.4697" x2="10.6621" y2="1.27728" stroke-width="1.5" />
    <line x1="1.53033" y1="1.46967" x2="10.7227" y2="10.6621" stroke-width="1.5" />
  </svg>

</template>

<script>
export default {
  name: "CrossIcon",
}
</script>

<style lang="scss" scoped>
line {
  stroke: inherit;
}
</style>